import ChangePasswordFormContainer from './ChangePasswordFormContainer';

export default ChangePasswordFormContainer;
